export default __webpack_public_path__ + "5aa60e5b1fc72fdc078cf4527e90968b.svg";